import { Box, Checkbox, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'
import type Employee from 'modules/employees/store/models/Employee'
import locations from 'modules/locations/store/collections/locations'

interface Props {
  employee: Employee
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: () => void
  onClick: () => void
  width: number
}

const OfficeCell = ({ bulkEditForm, isChecked, onChange, onClick, width }: Props) => {
  const handleChangeLocation = (id: unknown) => {
    bulkEditForm.setValues({
      location_id: id,
    })
    onChange()
  }

  const locationOptions = locations.map((location) => {
    return (
      <Selector.Option
        key={location.attributes.id}
        value={location.attributes.id}
        label={location.attributes.name}
        searchValue={location.attributes.name}
        isChecked={isChecked}
      >
        <Box width="full" overflowY="hidden">
          <Text.Normal size="200" weight="medium" ellipsis>
            {location.attributes.name}
          </Text.Normal>
        </Box>
      </Selector.Option>
    )
  })

  const remainingWidth = width - 78

  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width: `${width}px` }}
    >
      <Box flexNoShrink>
        <Checkbox checked={isChecked} onChange={onClick} />
      </Box>
      <Box style={{ width: `${remainingWidth}px` }}>
        <Selector.Popover
          blankLabel={i18n.t('common.empty')}
          allSelectedLabel={i18n.t('common.all')}
          placeholder={i18n.t('common.select')}
          searchPlaceholder={i18n.t('common.search')}
          value={
            +bulkEditForm.get('location_id').value ? [+bulkEditForm.get('location_id').value] : []
          }
          onChange={handleChangeLocation}
        >
          {locationOptions}
        </Selector.Popover>
      </Box>
    </Box>
  )
}

export default observer(OfficeCell)
